import {permissionsEnabled} from '@netx/core-permissions-next/enablers/permissionsEnabled';
import type {UserLevel} from '../constants';
import {getUserLevel} from './getUserLevel';
export {UserLevel} from '../constants';

/**
 * Checks if the current user's level meets or exceeds the specified `UserLevel`.
 * @deprecated Will always return `true` when new permissions are enabled
 * @param userLevel UserLevel to check against
 * @returns True if current user's level meets or exceeds the specified `UserLevel`, false otherwise
 */
export const currentUserMeetsUserLevel = (userLevel: UserLevel) => {
	if (permissionsEnabled()) return true;
	return getUserLevel() >= userLevel;
};
